import styled from "@emotion/styled";
import { Popover } from "@mui/material";
import { BookmarkButton } from "scmp-sdk/components/bookmark-button";
import { ShareButton } from "scmp-sdk/components/share-button";

import { fontRoboto, ZIndexLayer } from "shared/lib/styles";

export const MenuPopper = styled(Popover)`
  z-index: ${ZIndexLayer.Tooltip};
`;

export const ActionMenu = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  padding: 20px;
`;

export const StyledBookmarkButton = styled(BookmarkButton)`
  inline-size: 15px;
  block-size: 19px;
  margin-inline-end: 14px;
  padding: 0;

  & path:last-of-type {
    fill: #001246;
  }
`;

export const RemoveButton = styled.button`
  margin-inline-start: 10px;
  padding: 0;

  color: #4585ff;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  border: none;

  background: transparent;

  cursor: pointer;
`;

export const StyledShareButton = styled(ShareButton)`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 30px;
  block-size: 30px;

  rect {
    display: none;
  }
`;

export const ActionDivider = styled.div`
  inline-size: 1px;
  block-size: 20px;
  margin-inline: 5px;

  background: #bbbbbb;
`;
